import { Text } from '@quintoandar-tokko/jopijs';
import styles from './components.module.scss';

export default function PercentageValue({
  percentage,
  className = '',
  ...props
}) {
  const classNames = `${styles.percentageValue} ${className}`;

  const truncateToTwo = (num) => Math.trunc(num * 100) / 100;

  return (
    <Text className={classNames} {...props}>
      {truncateToTwo(percentage)}%
    </Text>
  );
}
